import { useQuery } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';
import { Segment } from 'Interfaces/FeatureFlip';


interface GetAllSegments{
  pageNumber?:number;
  pageSize?:number;
  query:string;
}

const getAllSegments = async (payload:GetAllSegments
) => {
  try {
    const url = paths.getAllSegments();
    const response = await axiosInstance.post(url, {input: payload});
    const segments = response?.data?.data?.segments?.result;

    return Array.isArray(segments) ? segments as Segment[] : [];
  } catch (error) {
    return Promise.reject(error);
  }
  
};



export const useGetAllSegments = (payload:GetAllSegments,
  options?: {
       onSuccess?: (data: Segment[]) => void;
     }) => {
    return useQuery(
      ['get-all-segments', payload],
      () => getAllSegments(payload),
      {
        enabled:false ,
        ...options,
      }
    );
  };